import IntroDashboardView from './IntroDashboardView';

export default IntroDashboardView;
